// extracted by mini-css-extract-plugin
module.exports = {"spotify-settings":"SpotifySettings_spotify-settings__2JhEi","text":"SpotifySettings_text__2EYxv"};